const brandApiList = {
  addBrand: '/manage/goods/brand/add',
  brandList: '/manage/goods/brand/list',
  getMallBrand: '/v0.2/brand/get_brand_all'
}
export default brandApiList



// WEBPACK FOOTER //
// ./src/service/basic/brandApiList.js